import { gql } from '__generated__';

export const CouponFieldsFragment = gql(`
  fragment CouponFields on Coupon {
    id
    prefix
    type
    value
    start_date
    end_date
    max_uses
    available
    notes
    active
    uses
    codes_count
    download_url
    example {
      id
      value
    }
    tickets {
      id
    }
    products {
      id
    }
  }
`);

export default gql(`
  query GetCoupon($event_id: ID!, $coupon_id: ID!) {
    coupon(id: $coupon_id) {
      ...CouponFields
    }
    event(id: $event_id) {
      id
      locale
      tickets {
        id
        title
        standard_promotion {
          id
          amount
        }
      }
      products {
        id
        title
        type
        standard_promotion {
          id
          amount
        }
      }
    }
  }
`);
